module.exports = __webpack_public_path__ + "media/images/woman-success-green-bg-bc9bc6da7da114214d173efcc126987e.svg";